/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MagicTokenRequest
 */
export interface MagicTokenRequest {
    /**
     * If true, an e-mail is sent to the user with the token.
     * @type {boolean}
     * @memberof MagicTokenRequest
     */
    email?: boolean;
    /**
     * This is the target of the request. It is used to redirect the user to the proper app after consuming the token.
     * @type {string}
     * @memberof MagicTokenRequest
     */
    target: MagicTokenRequestTargetEnum;
}


/**
 * @export
 */
export const MagicTokenRequestTargetEnum = {
    Unknown: 'UNKNOWN',
    ChatAppLocal: 'CHAT_APP_LOCAL',
    ChatAppDev: 'CHAT_APP_DEV',
    ChatApp: 'CHAT_APP',
    WebAppLocal: 'WEB_APP_LOCAL',
    WebAppDev: 'WEB_APP_DEV',
    WebApp: 'WEB_APP'
} as const;
export type MagicTokenRequestTargetEnum = typeof MagicTokenRequestTargetEnum[keyof typeof MagicTokenRequestTargetEnum];


/**
 * Check if a given object implements the MagicTokenRequest interface.
 */
export function instanceOfMagicTokenRequest(value: object): value is MagicTokenRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function MagicTokenRequestFromJSON(json: any): MagicTokenRequest {
    return MagicTokenRequestFromJSONTyped(json, false);
}

export function MagicTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MagicTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'target': json['target'],
    };
}

export function MagicTokenRequestToJSON(json: any): MagicTokenRequest {
    return MagicTokenRequestToJSONTyped(json, false);
}

export function MagicTokenRequestToJSONTyped(value?: MagicTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'target': value['target'],
    };
}

